import { useStaticQuery, graphql } from 'gatsby'

export const useResultsQuery = () => {
const { wpPage } = useStaticQuery(
    graphql`
    query ResultsQuery {
      wpPage(slug: {eq: "home"}) {
        home {
          resultsTitle
          resultsSubtitle
          resultsH1
          resultsTabs {
            resultsTabTitle
            resultsTabParagraph
          }
        }
      }
    }
  `
);
return wpPage.home;
}